<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/az/azdistributors"
    >
<!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <!-- EXISTING -->
            <div v-if="data != null" class="headline" :alvqa="alvqa + '-title'">
                {{ data.name }}
            </div>
        </template>

<!-- EDIT FORM -->
        <template v-slot:editForm="{ data }">
            <!-- Picture -->
            <v-col cols="1">
                <v-row>
                    <v-col v-if="data != null">
                        <v-img 
                            v-if="data.pictureBig !== null"
                            :src="data.pictureBig"
                        ></v-img>
                        <v-img
                            v-else
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <!-- <BaseIcon 
                                    @click="uploadPicture()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_CAPTION_UPLOAD_IMAGE"
                                />   -->
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
            </v-col> 
            <v-col cols="5">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Distributor"
                        :label="$t('lang_AZ_GROUPS_CAPTION_GROUP_NAME')" 
                        rules="required"
                        :clearable="false"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-group-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AddressRowOne"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_1')"
                        :alvqa="alvqa + '-textfield-address-row-one'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AddressRowTwo"
                        :clearable="false"
                        :disabled="true"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_2')"
                        :alvqa="alvqa + '-textfield-address-row-two'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Zip"
                        :clearable="false"
                        :disabled="true"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ZIP')"
                        :alvqa="alvqa + '-textfield-zip'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="City"
                        :clearable="false"
                        :disabled="true"
                        :label="$t('lang_AZ_PERSONS_CAPTION_CITY')"
                        :alvqa="alvqa + '-textfield-city'"
                    />
                </v-row>  
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Country"
                        :items="countries" 
                        :label="$t('lang_AZ_PERSONS_CAPTION_COUNTRY')"  
                        :clearable="false"
                        :disabled="true"
                        :alvqa="alvqa + '-dropdown-country'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="FullShippingAddress"
                        rows="5"
                        :label="$t('lang_AZ_GROUPS_CAPTION_SHIPPING_ADDRESS')" 
                        :alvqa="alvqa + '-textarea-full-shipping-address'"
                    />
                </v-row>
            </v-col>

            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_GENERIC_CAPTION_ALVID')"
                        :clearable="false"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-alvid'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SalesCountry"
                        :items="countries" 
                        :label="$t('lang_AZ_DISTRIBUTORS_CAPTION_SALES_COUNTRY')"  
                        :alvqa="alvqa + '-dropdown-sales-country'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Type"
                        :items="distributorTypes" 
                        :label="$t('lang_GENERIC_AZ_CAPTION_TYPE')"
                        :multiple="true"
                        :selection="true"
                        :alvqa="alvqa + '-dropdown-type'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Visibility"
                        :items="visibilityItems" 
                        :clearable="false"
                        :label="$t('lang_AZ_PERSONS_CAPTION_VISIBILITY')"
                        :alvqa="alvqa + '-dropdown-visibility'" 
                    />
                </v-row>
                <v-row class="mt-6">
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="Notes"
                        rows="3"
                        :label="$t('lang_GENERIC_CAPTION_NOTES')" 
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
                <v-row class="mt-3">
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="ShipmentNote"
                        rows="5"
                        :label="$t('lang_AZ_DISTRIBUTORS_CAPTION_SHIPMENT_NOTE')" 
                        :alvqa="alvqa + '-textarea-shipmentnote'"
                    />
                </v-row>
            </v-col>
        </template>
        <template v-slot:panels>
            <AzDistributorsMetadataEditPanel />
            <AzDistributorsFinanceEditPanel />
        </template>
    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'

import AzDistributorsMetadataEditPanel from './_panels/AzDistributorsMetadataEditPanel'
import AzDistributorsFinanceEditPanel from './_panels/AzDistributorsFinanceEditPanel'

import { DropdownAzDistributorsType } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "AzDistributorsEdit",
    components: {
        BaseEditPage,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageTextarea,
        
        AzDistributorsMetadataEditPanel,
        AzDistributorsFinanceEditPanel
    },
    data() {
        return {
            context:  'AzDistributors',
            alvqa: 'az-distributors-edit-form'
        }
    },
    computed: {
        countries() { return this.$alvPlugin.getListOfTranslatedCountries() },
        distributorTypes() { 
            let types = JSON.parse(JSON.stringify(DropdownAzDistributorsType))
            types.forEach(type => {
                type['text'] = this.$t(type['text'])
            })

            return types
        },
        visibilityItems() { 
            let visibilityArr
            let visibility = this.$store.getters['getVisibility' + this.$i18n.locale.toUpperCase()] 
            if(visibility === undefined) visibility = this.$store.getters.getVisibilityEN // fallback EN

            if(visibility !== undefined) {
                visibilityArr = JSON.parse(JSON.stringify(visibility))
                visibilityArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-visibility-' + element.value
                });
            } else {
                visibilityArr = []
            }

            return visibilityArr
        },
    },
    methods: {

    },
    mounted() {
        this.$store.commit('setCountries')
        this.$store.commit('setVisibility')
    }
}
</script>